/**
 * Page-scoped modules.
 *
 * Swup swaps #swup without a page reload, so anything bound to elements inside
 * it has to be set up on every visit and torn down before the content is
 * replaced. Modules register with onPage(init):
 *
 *   onPage((root) => {
 *     const el = root.querySelector('[data-my-block]')
 *     if (!el) return
 *     const instance = setup(el)
 *     return () => instance.destroy()   // runs before the next swap
 *   })
 *
 * init(root) runs on the initial load and after every visit; the function it
 * returns runs before the content is replaced — and on remountPage(), which
 * the easy-mode toggle uses to rebuild the page in the other view.
 */
const inits = []
const cleanups = []
let currentRoot = null

function run(init, root) {
  try {
    const cleanup = init(root)
    if (typeof cleanup === 'function') cleanups.push(cleanup)
  } catch (error) {
    console.error('[page] init failed', error)
  }
}

export function onPage(init) {
  inits.push(init)
  if (currentRoot) run(init, currentRoot)
}

export function mountPage(root) {
  currentRoot = root
  inits.forEach((init) => run(init, root))
}

export function unmountPage() {
  cleanups
    .splice(0)
    .reverse()
    .forEach((cleanup) => {
      try {
        cleanup()
      } catch (error) {
        console.error('[page] cleanup failed', error)
      }
    })
  currentRoot = null
}

export function remountPage() {
  const root = currentRoot ?? document.querySelector('#swup')
  unmountPage()
  if (root) mountPage(root)
}
